<div class="lucky-bucks-container">
  <div class="header-section">
    <h2>Add Lucky Bucks to User Wallet</h2>
    <p class="subtitle">Add virtual money (Lucky Bucks) to customer wallets. Users will receive an email notification.
    </p>
  </div>

  <div class="form-container">
    <form [formGroup]="luckyBucksForm" (ngSubmit)="onSubmit()">
      <!-- Add to All Users Option -->
      <div class="form-row">
        <div class="form-group full-width">
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="addToAllUsers" (change)="onAddToAllUsersChange()"
              [ngModelOptions]="{standalone: true}" [disabled]="isLoading">
            <span class="checkbox-text">
              <strong>Add Lucky Bucks to All Users</strong>
              <small>(This will add the specified amount to all active customer accounts)</small>
            </span>
          </label>
        </div>
      </div>

      <!-- Also Add to New Users Option -->
      <div class="form-row" *ngIf="addToAllUsers">
        <div class="form-group full-width">
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="alsoAddToNewUsers" [ngModelOptions]="{standalone: true}"
              [disabled]="isLoading">
            <span class="checkbox-text">
              <strong>Also Add to Future New Users</strong>
              <small>(Any user who signs up after this will automatically receive this amount in their wallet. This will
                replace any existing default amount for new users.)</small>
            </span>
          </label>
        </div>
      </div>

      <!-- User Selection -->
      <!-- <div class="form-row" *ngIf="!addToAllUsers">
        <div class="form-group full-width">
          <label class="form-label">Select User <span class="required">*</span></label>
          <div class="user-search-container">
            <input type="text" class="form-control user-search-input" placeholder="Search by name or email..."
              [(ngModel)]="searchTerm" (input)="onUserSearch()" (focus)="onUserSearchFocus()"
              (blur)="onUserSearchBlur()" (keydown)="onKeyDown($event)" [ngModelOptions]="{standalone: true}"
              [disabled]="isLoading" autocomplete="off" [attr.aria-expanded]="showDropdown"
              [attr.aria-autocomplete]="'list'">

            <div class="user-dropdown" *ngIf="showDropdown && filteredUsers.length > 0 && !selectedUser"
              (mousedown)="$event.preventDefault()">
              <div class="user-option" [class.highlighted]="highlightedIndex === i"
                *ngFor="let user of filteredUsers; let i = index" (mousedown)="onUserSelect(user, $event)"
                (click)="onUserSelect(user, $event)" (mouseenter)="highlightedIndex = i">
                <div class="user-info">
                  <strong>{{user.firstName}} {{user.lastName}}</strong>
                  <span class="user-email">{{user.emailId}}</span>
                </div>
              </div>
            </div>

            <div class="user-dropdown no-results"
              *ngIf="showDropdown && filteredUsers.length === 0 && searchTerm.trim() !== ''">
              <div class="user-option">
                <div class="user-info">
                  <span>No users found matching "{{searchTerm}}"</span>
                </div>
              </div>
            </div>

            <div class="selected-user" *ngIf="selectedUser">
              <div class="selected-user-info">
                <strong>{{selectedUser.firstName}} {{selectedUser.lastName}}</strong>
                <span class="user-email">{{selectedUser.emailId}}</span>
              </div>
              <button type="button" class="clear-btn" (click)="clearUserSelection()">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
          <input type="hidden" formControlName="userId">
          <small class="form-text text-muted"
            *ngIf="luckyBucksForm.get('userId')?.invalid && luckyBucksForm.get('userId')?.touched">
            Please select a user
          </small>
        </div>
      </div> -->

      <div class="form-row" *ngIf="!addToAllUsers">
        <div class="form-group full-width">
          <!-- <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Select Users</mat-label>
            <mat-select formControlName="userIdList" multiple>
              @for (user of filteredUserForDropdown; track user.id) {
              <mat-option [value]="user.id">
                {{ user.firstName }} {{ user.lastName }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Select Users</mat-label>

            <mat-chip-grid #chipGrid>
              <mat-chip-row *ngFor="let user of selectedUsers" (removed)="remove(user)" style="border: 1px solid var(--theme-color);">
                {{ user.firstName }} {{ user.lastName }} ({{ user.emailId }})
                <mat-icon matChipRemove style="color:  var(--theme-color);">cancel</mat-icon>
              </mat-chip-row>
            </mat-chip-grid>

            <input matInput [formControl]="userCtrl" [matAutocomplete]="auto" [matChipInputFor]="chipGrid"
              placeholder="Search users..." />

            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
              <mat-option *ngFor="let user of filteredUserForDropdown | async" [value]="user">
                {{ user.firstName }} {{ user.lastName }} ({{ user.emailId }})
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

        </div>
      </div>

      <!-- Info message when adding to all users -->
      <div class="form-row" *ngIf="addToAllUsers">
        <div class="form-group full-width">
          <div class="info-alert">
            <i class="fa fa-info-circle"></i>
            <span>You are about to add Lucky Bucks to <strong>all active customer accounts</strong>. Each user will
              receive an email notification.</span>
          </div>
        </div>
      </div>

      <!-- Amount -->
      <div class="form-row">
        <div class="form-group"
          [ngClass]="{'has-error': luckyBucksForm.get('amount')?.invalid && luckyBucksForm.get('amount')?.touched}">
          <label class="form-label">Amount (Lucky Bucks) <span class="required">*</span></label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input type="number" class="form-control" formControlName="amount" placeholder="0.00" step="0.01" min="0.01"
              appTwoDecimalWithMaxLimit [maxLimit]="1000">
          </div>
          <small class="form-text text-danger"
            *ngIf="luckyBucksForm.get('amount')?.invalid && luckyBucksForm.get('amount')?.touched">
            Amount must be greater than $0.00
          </small>
        </div>
      </div>

      <!-- Description -->
      <div class="form-row">
        <div class="form-group full-width">
          <label class="form-label">Description (Optional)</label>
          <textarea class="form-control" formControlName="description" rows="3"
            placeholder="Add a note about this credit (e.g., 'Promotional bonus', 'Reward for loyalty', etc.)"
            maxlength="500"></textarea>
          <small class="form-text text-muted">
            {{luckyBucksForm.get('description')?.value?.length || 0}} / 500 characters
          </small>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="form-actions">
        <button type="submit" class="btn btn-primary submit-btn"
          [disabled]="luckyBucksForm.invalid || isLoading || (!addToAllUsers && luckyBucksForm.get('userIdList')?.value?.length === 0)">
          <span *ngIf="!isLoading">
            <i class="fa fa-plus-circle"></i>
            {{ addToAllUsers ? 'Add Lucky Bucks to All Users' : 'Add Lucky Bucks' }}
          </span>
          <span *ngIf="isLoading">
            <i class="fa fa-spinner fa-spin"></i>
            {{ addToAllUsers ? 'Processing... This may take a moment' : 'Processing...' }}
          </span>
        </button>
        <button type="button" class="btn btn-secondary reset-btn" (click)="onReset()" [disabled]="isLoading">
          <i class="fa fa-refresh"></i> Reset
        </button>
      </div>
    </form>
  </div>

  <!-- Info Section -->
  <div class="info-section">
    <div class="info-card">
      <h4><i class="fa fa-bullhorn"></i> Information</h4>
      <ul>
        <li><i class="fa fa-dot-circle-o"></i> Users will receive an email notification when Lucky Bucks are added to their wallet.</li>
        <li><i class="fa fa-dot-circle-o"></i> Lucky Bucks can be used during checkout to pay for purchases.</li>
        <li><i class="fa fa-dot-circle-o"></i> If the cart value exceeds the wallet balance, the remaining amount will be charged to the payment method.
        </li>
        <li><i class="fa fa-dot-circle-o"></i> All transactions are recorded in the user's wallet transaction history.</li>
        <li><i class="fa fa-dot-circle-o"></i> When "Also Add to Future New Users" is checked, any new user who signs up will automatically receive the
          specified amount in their wallet.</li>
      </ul>
    </div>
  </div>
</div>